import { Alert } from "antd";
import React from "react";

interface WarningMessageProps {
  isRoundFinished: boolean;
}

const WarningMessage: React.FC<WarningMessageProps> = ({ isRoundFinished }) => {
  const message = isRoundFinished
    ? "The interview round is over. Thank you for participating."
    : "Please do not switch between windows or tabs, your screen is recording.";
  return (
    <Alert
      message={message}
      type="warning"
      showIcon
      style={{
        backgroundColor: "#FFFBE6",
        marginBottom: "20px",
        marginTop: "20px",
        border: "none",
      }}
    />
  );
};

export default WarningMessage;
